import React from 'react';
import PropTypes from 'prop-types';

import {
  Alert,
  Box,
  Chip,
  Switch,
  Typography,
} from '@mui/material';

import texts from '../texts';

const AutoSaveToggle = ({ checked, onChange }) => (
  <Alert
    severity={checked ? 'success' : 'info'}
    variant="outlined"
    action={(
      <Switch
        color="success"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        inputProps={{ 'aria-label': texts.autoSaveTitle }}
      />
    )}
    sx={{ mb: 2, alignItems: 'center' }}
  >
    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
      <Typography component="span" fontWeight="bold">
        {texts.autoSaveTitle}
      </Typography>
      <Chip
        size="small"
        color={checked ? 'success' : 'default'}
        label={checked ? texts.autoSaveOn : texts.autoSaveOff}
      />
    </Box>
    <Typography variant="body2" color="text.secondary">
      {texts.autoSaveDescription}
    </Typography>
  </Alert>
);

AutoSaveToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AutoSaveToggle;
